import { combineReducers } from '@reduxjs/toolkit';

import subtitles from './subtitles/reducers';
import previews from './previews/slice';

export default combineReducers({
    subtitles,
    [previews.name]: previews.reducer,
});
